import { render, staticRenderFns } from "./PointLogs.vue?vue&type=template&id=1ee74036&scoped=true"
import script from "./PointLogs.vue?vue&type=script&lang=js"
export * from "./PointLogs.vue?vue&type=script&lang=js"
import style0 from "./PointLogs.vue?vue&type=style&index=0&id=1ee74036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee74036",
  null
  
)

export default component.exports